module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "zk-menu-item-group"
  }, [_c('div', {
    staticClass: "zk-menu-item-group__title",
    style: ({
      'padding-left': _vm.paddingLeft + 'px'
    })
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('ul', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-625b86e3"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/menu/src/menu-item-group.vue
// module id = 261
// module chunks = 0